import React from "react";

const HorizontalBar = ({ barData = [] }) => {
  barData?.sort();
  return (
    <div className="">
      
      <div className="space-y-2 md:hidden">
        {barData.map((party, index) => (
          <div key={index} className="flex items-center gap-2 ms-lg-5">
            <div className="min-w-8 max-w-8 mt-3">
              <img src={party.icon} alt={party.name} />
            </div>
            <div className="text-[12px] font-semibold">
              <p className="mb-1">{party.name}</p>
              <div
                className={` min-w-[3.5rem] max-w-[14rem]  w-[${parseInt(
                  Math.max(5, party?.result)
                )}rem] flex justify-end  font-bold px-2`}
                // className={`${
                //   party.color
                // } min-w-[3.5rem] max-w-[26rem]  w-[${parseInt(
                //   Math.max(5, party?.result)
                // )}rem] flex justify-end  font-bold px-2`}
                style={{
                  background: `linear-gradient(to right, ${party.color || "#ccc"
                    } 0%, white)`,
                  width: `${Math.max(5, party?.result)}vw`,
                }}
              >
                {party?.result}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="space-y-2 hidden md:block">
        {barData.map((party, index) => (
          <div key={index} className="flex items-center gap-2 ms-lg-5">
            <div className="min-w-8 max-w-8 mt-3">
              <img src={party.icon} alt={party.name} />
            </div>
            <div className="text-[12px] font-semibold">
              <p className="mb-1">{party.name}</p>
              <div
                className={` min-w-[3.5rem] max-w-[20rem]  w-[${parseInt(
                  Math.max(5, party?.result)
                )}rem] flex justify-end  font-bold px-2`}
                // className={`${
                //   party.color
                // } min-w-[4rem] max-w-[26rem]  w-[${parseInt(
                //   Math.max(5, party?.result)
                // )}rem] flex justify-end  font-bold px-2`}
                style={{
                  background: `linear-gradient(to right, ${party.color || "#ccc"
                    } 0%, white)`,
                  width: `${Math.max(5, party?.result + 5) / 2.1 || 16 - index * 4
                    }vw`,
                }}
              >
                {party?.result}{/* {party?.result || 16 - index * 4}% */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HorizontalBar;
